import { LANGUAGE_POLICY } from '@/consts';
import { Policy } from '../../../../types/types';
import { LANGUAGES } from '../../../../content/languages';

const getPolicyLanguage = (policy: Policy): LANGUAGES => (
    policy?.settings.access?.find(({ id }) => id === LANGUAGE_POLICY)?.value as LANGUAGES
);

export default getPolicyLanguage;
